export const enum ENotAuthNavigation {
  MAIN = '/',
  PAGES = '/pages',
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
  ACCOUNT_LOGIN = '/account-login',
  REGISTRATION = '/registration',
  CONTACT_US = '/contact-us',
  LOST_PASSWORD = '/lost-password',
  SEARCH = '/search',
  ACCOUNT = '/account',
  CATEGORY_OF_CARD = '/category-of-card',
  CARD = '/card',
  RESEND_CARD = '/resend-card',
  CUSTOM_CARD = '/custom-card',
  THANK_YOU = '/thank-you',
  PRIVACY_POLICY = '/privacy-policy',
  NOT_FOUND = '/404',
}

export const enum EAuthNavigation {
  MAIN = '/',
  ACCOUNT = '/account',
}
